import authorData from "@content/en/blog/authors.yaml";

interface Author {
  name: string;
  bio: string;
  twitter: string;
  linkedIn: string;
  image: string;
  title: string;
}

export default Author;

export function getAuthorData(name: string) {
  return authorData.authors.filter((author) => author.name === name)[0];
}
